import { ConnectComponent } from '../_components/ConnectComponent'
import { SaveAndRetreivePresenter } from './SaveAndRetreive.presenter'
import { SaveAndRetreiveView } from './SaveAndRetreive.view'

export const SaveAndRetreive = ConnectComponent(
  SaveAndRetreiveView,
  SaveAndRetreivePresenter,
)
